export default __webpack_public_path__ + "static/media/second.bb5d5f8e.png";